import { createRouter, createWebHistory } from 'vue-router';
import { LoginCallback, navigationGuard } from '@okta/okta-vue';
import HomeView from '../views/HomeView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue')
  },
  {
    path: '/caleb_berkstresser',
    name: 'caleb_berkstresser',
    component: () => import('../views/CalebBerkstresserView.vue')
  },
  {
    path: '/cj_berkstresser',
    name: 'cj_berkstresser',
    component: () => import('../views/CJBerkstresserView.vue')
  },
  {
    path: '/custom_tutoring',
    name: 'custom_tutoring',
    component: () => import('../views/CustomTutoringView.vue')
  },
  {
    path: '/calculus_limits',
    name: 'calculus_limits',
    component: () => import('../views/CalculusLimitsView.vue')
  },
  {
    path: '/calculus_derivatives',
    name: 'calculus_derivatives',
    component: () => import('../views/CalculusDerivativesView.vue')
  },
  {
    path: '/calculus_integrals',
    name: 'calculus_integrals',
    component: () => import('../views/CalculusIntegralsView.vue')
  },
  {
    path: '/calculus_final',
    name: 'calculus_final',
    component: () => import('../views/CalculusFinalView.vue')
  },
  {
    path: '/latin101',
    name: 'latin101',
    component: () => import('../views/Latin101View.vue')
  },
  {
    path: '/latin102',
    name: 'latin102',
    component: () => import('../views/Latin102View.vue')
  },
  {
    path: '/prealgebra',
    name: 'prealgebra',
    component: () => import('../views/PreAlgebraView.vue')
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import('../views/PricingView.vue')
  },
  {
    path: '/prealgebra101',
    name: 'prealgebra101',
    component: () => import('../views/PreAlgebra101View.vue')
  },
  {
    path: '/prealgebra102',
    name: 'prealgebra102',
    component: () => import('../views/PreAlgebra102View.vue')
  },
  {
    path: '/prealgebra103',
    name: 'prealgebra103',
    component: () => import('../views/PreAlgebra103View.vue')
  },
  {
    path: '/prealgebra104',
    name: 'prealgebra104',
    component: () => import('../views/PreAlgebra104View.vue')
  },
  {
    path: '/prealgebra105',
    name: 'prealgebra105',
    component: () => import('../views/PreAlgebra105View.vue')
  },
  {
    path: '/trumpet101',
    name: 'trumpet101',
    component: () => import('../views/Trumpet101View.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notfound',
    component: () => import('../views/NotFoundPageView.vue'),
  },
  { path: '/callback', component: LoginCallback }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(navigationGuard);

export default router;
